module.exports = "/images/Cross.svg?e0f5fdade99ed6ff2fbc9f936c1ccce0";


//////////////////
// WEBPACK FOOTER
// ./src/img/details/Cross.svg
// module id = 110
// module chunks = 0